import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  View,
  ScrollView,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import InputLayout from "../components/InputLayout";
import ButtonLayout from "../components/ButtonLayout";
import makeRequest from "../components/makeRequest";

export default function (props) {
  const [input, setInput] = useState("");
  const [failed, setFailed] = useState(false);
  const testConfirmacion = async () => {
    const response = await makeRequest("users/confirmar/" + input, "GET");
    props.navigation.dispatch(StackActions.replace("UserScreen"));
  };
  return (
    <BackgroundUser scroll={true}>
      <Logo></Logo>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <Title style={{ marginBottom: 20 }}>
          Introduzca el código que recibirá por SMS
        </Title>
        <InputSMS onChange={(text) => setInput(text)} />
        {failed && (
          <Text
            style={{
              color: "red",
              textAlign: "center",
              fontWeight: "bold",
              marginTop: 20,
            }}>
            Compruebe que ha escrito el número correctamente
          </Text>
        )}
        {input.length === 6 && (
          <ButtonLayout
            text={"Confirmar"}
            onPress={testConfirmacion}></ButtonLayout>
        )}
      </View>
    </BackgroundUser>
  );
}

function InputSMS(props) {
  const [num, setNum] = useState("");

  return (
    <View style={{ flexDirection: "row", justifyContent: "space-around" }}>
      <TextInput
        maxLength={6}
        keyboardType='numeric'
        value={num}
        onChangeText={(text) => {
          setNum(text);
          props.onChange(text);
        }}
        style={{
          backgroundColor: "white",
          height: 100,
          width: "90%",
          color: "#3E4672",
          borderRadius: 10,
          textAlign: "center",
          fontSize: 40,
        }}></TextInput>
    </View>
  );
}
